module.exports = __webpack_public_path__ + "img/thridPayBgBlue.2357e847.jpg";